import { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useSocketContext } from "./SocketContext";
import { toast } from "react-toastify";
import axios from "axios";
import welcomeMessage from "./assets/audios/messageTone3.mp3";
import { setNewOrders } from "./slices/newOrdersSlice";
import { printReceipt } from "./utils/printReceipt";

const useListenMessages = () => {
  const { socketDetails: socket } = useSocketContext();
  const { userInfo } = useSelector((state) => state.auth);
  const [isToggled, setIsToggled] = useState(userInfo?.audioOn);

  const dispatch = useDispatch();

  // The listener below is attached once per socket, so it must read
  // userInfo through a ref; a captured copy keeps printing to the
  // outlet/printer port that was in redux when the socket connected
  const userInfoRef = useRef(userInfo);
  useEffect(() => {
    userInfoRef.current = userInfo;
  }, [userInfo]);

  useEffect(() => {
    if (!socket) return;
    try {
      const handleNewMessage = async (orderDetails) => {
        // console.log(new Date().getMinutes() + " : " + new Date().getSeconds());
        // toast.success("new data available : ");
        dispatch(setNewOrders([orderDetails.itemCreated]));

        // Outlet orders are printed by the sales screen that placed them;
        // the server also echoes them to this room, so only online orders
        // are printed from here
        if (orderDetails?.itemCreated?.orderType === "outlet") return;

        toast.success(() => (
          <>
            <audio src={welcomeMessage} type="audio/mp3" autoPlay={true} />{" "}
            New Order has Arrived
          </>
        ));
        await printReceipt(orderDetails?.itemCreated, userInfoRef.current);
      };

      // Attach listener
      socket.on("new_order_update", handleNewMessage);

      // Cleanup listener
      return () => {
        socket.off("new_order_update", handleNewMessage);
      };
    } catch (err) {
      console.error("Print error:", err.message);
      toast.error("Print error:", err.message);
    }
  }, [socket]);
};
export default useListenMessages;
